import React, { memo } from 'react';
import { Row } from 'components/Grid/Grid';
import PaymentAlert from './PaymentAlert/PaymentAlert';
import CardExpirationAlert from './CardExpirationAlert/CardExpirationAlert';
import TimezoneAlert from './TimezoneAlert/TimezoneAlert';

const HeaderAlert = () => {
  return (
    <Row gutter={[0, 2]}>
      <PaymentAlert />
      <CardExpirationAlert />
      <TimezoneAlert />
    </Row>
  );
};

export default memo(HeaderAlert);
